import { useState } from 'react'
import { useSetPasswordMutation } from '@/entities/employee'
import { errorMessage } from '@/shared/api'
import { Button } from '@/shared/ui/button'
import { Field, Input } from '@/shared/ui/field'
import { toast } from '@/shared/ui/toast'

interface ChangePasswordFormProps {
  employeeId: string
  /** Свой пароль меняют, предъявив текущий; чужой выдают без него. */
  own: boolean
}

export function ChangePasswordForm({ employeeId, own }: ChangePasswordFormProps) {
  const change = useSetPasswordMutation()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    change.mutate(
      { employeeId, newPassword: next, ...(own ? { currentPassword: current } : {}) },
      {
        onSuccess: () => {
          setCurrent('')
          setNext('')
          toast.success(own ? 'Пароль изменён' : 'Пароль выдан — передайте его лично')
        },
      },
    )
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-4">
      {own && (
        <Field label="Текущий пароль">
          {(props) => (
            <Input
              {...props}
              type="password"
              value={current}
              autoComplete="current-password"
              onChange={(e) => setCurrent(e.target.value)}
            />
          )}
        </Field>
      )}
      <Field label="Новый пароль" hint="Длинный и не похожий на логин">
        {(props) => (
          <Input
            {...props}
            type="password"
            value={next}
            autoComplete="new-password"
            onChange={(e) => setNext(e.target.value)}
          />
        )}
      </Field>
      {change.isError && (
        <p role="alert" className="text-sm text-accent">
          {errorMessage(change.error)}
        </p>
      )}
      <Button type="submit" variant="secondary" disabled={change.isPending || next.length === 0}>
        {own ? 'Сменить пароль' : 'Выдать пароль'}
      </Button>
    </form>
  )
}
